import { render, staticRenderFns } from "./order_delete_modal.vue?vue&type=template&id=6a395f04&scoped=true"
import script from "./order_delete_modal.vue?vue&type=script&lang=js"
export * from "./order_delete_modal.vue?vue&type=script&lang=js"
import style0 from "./order_delete_modal.vue?vue&type=style&index=0&id=6a395f04&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a395f04",
  null
  
)

export default component.exports